import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en.js'
import zhLocale from './zh.js'

Vue.use(VueI18n)
// en_US
// zh-CN
const messages = {
  en_US: enLocale,
  'zh-CN': zhLocale,
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en_US',
  messages,
  fallbackLocale: 'en_US',
})

export default i18n
